export function test(message="hi") {
    console.log(message);
}
export var message = "fired test in module.js";
